import { render, staticRenderFns } from "./process_map.vue?vue&type=template&id=23f4f3b0&scoped=true&"
import script from "./process_map.vue?vue&type=script&lang=js&"
export * from "./process_map.vue?vue&type=script&lang=js&"
import style0 from "./process_map.vue?vue&type=style&index=0&id=23f4f3b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f4f3b0",
  null
  
)

export default component.exports